import {
	type FieldCategory,
	toFieldCategory,
} from '@atlassian/jira-common-rest/src/internal/simplified/1.0/projects/id/issuetypes/id/types.tsx';
import type { CategoryTransformer } from './types.tsx';

/**
 * Transform category strings used within layout item categories and {@link FieldOperations#categoriesWhitelist} into a
 * SWIFT compatible {@link FieldCategory}.
 */
export const transformCategory: CategoryTransformer = (containerType: string): FieldCategory =>
	toFieldCategory(containerType.toLowerCase());
